import { apiClient } from 'modules/core/lib/mobx-rest'
import { Model } from 'modules/core/lib/mobx-rest'

import type { ExecutionHistoryAggregateActionTaskState } from 'modules/automations/lib/enums'
import type { ExecutionHistoryEntryState } from 'modules/automations/lib/enums'
import { ExecutionHistoryAggregateActionState } from 'modules/automations/lib/enums'

import type { IAction } from './Action'

export interface ExecutionHistoryAggregateActionTask {
  id: string
  name: string
  state: ExecutionHistoryAggregateActionTaskState
  error?: string
  started_at: string
  finished_at?: string
}

export interface ExecutionHistoryAggregateAction {
  id: string
  parent_id?: string
  data?: IAction
  state: ExecutionHistoryAggregateActionState
  error?: string
  started_at?: string
  finished_at?: string
  tasks: Record<string, ExecutionHistoryAggregateActionTask>
}

export interface ExecutionHistoryAggregateAutomation {
  automation_id: string
  automation_name: string
  state: ExecutionHistoryEntryState
  started_at: string
  finished_at?: string
  actions: Record<string, ExecutionHistoryAggregateAction>
}

interface IExecutionHistoryEntry {
  id: string
  automation_id: string
  state: ExecutionHistoryEntryState
  started_at: string
  finished_at?: string
}

export class ExecutionHistoryEntry extends Model<IExecutionHistoryEntry> {
  static urlRoot() {
    return '/automations/execution_history'
  }

  get id(): string {
    return this.attributes.id
  }

  get state(): ExecutionHistoryEntryState {
    return this.attributes.state
  }

  get startedAt(): string {
    return this.attributes.started_at
  }

  get finishedAt(): string | undefined {
    return this.attributes.finished_at
  }

  async fetchAggregate(): Promise<ExecutionHistoryAggregateAutomation> {
    const url = ExecutionHistoryEntry.staticUrl(String(this.id)) + '/aggregate'

    return (await apiClient().get(url)) as Promise<ExecutionHistoryAggregateAutomation>
  }
}
